import React, { useEffect, useState } from "react";
import "./index.scss";
import Close from "../Icons/Close";
import Arrow from "../Icons/Arrow";

type Props = {
  media: any[];
};

function Slideshow(props: Props) {
  const [selectedMediaIndex, setSelectedMediaIndex] = useState<null | number>(
    null
  );

  const changePreview = (value: number) => {
    if (selectedMediaIndex === null) return;
    let newIndex = selectedMediaIndex + value;
    const totalMedia = props.media.length;
    if (newIndex >= totalMedia) {
      newIndex = 0;
    } else if (newIndex < 0) {
      newIndex = totalMedia - 1;
    }
    setSelectedMediaIndex(newIndex);
  };

  const resetMedia = () => {
    setSelectedMediaIndex(null);
  };

  return (
    <>
      <div className="slideshow">
        {props.media.map((item: any, index: number) => {
          return (
            <img
              onClick={() => setSelectedMediaIndex(index)}
              src={item.src}
              key={index}
            />
          );
        })}
      </div>

      <div
        className={`preview fadeInAndOut ${
          selectedMediaIndex != null ? "fadeIn" : "fadeOut"
        }`}
      >
        <div className="close" onClick={() => resetMedia()}>
          <Close />
        </div>
        <div className="close small" onClick={() => resetMedia()}>
          <Close />
        </div>
        <div className="arr prev" onClick={() => changePreview(-1)}>
          <Arrow />
        </div>
        <div className="arr next" onClick={() => changePreview(1)}>
          <Arrow />
        </div>
        {selectedMediaIndex != null && (
          <img src={props.media[selectedMediaIndex].src} />
        )}
      </div>
    </>
  );
}

export default Slideshow;
